(ns common.schema.entities.workspace.kyc.templates.lifeline.substantial-us-owner
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(defn process-not-in-draft-status?
  [_answers kyc-process]
  (not= (:kyc-process/status kyc-process)
        :kyc-process.status/draft))

(def schema
  {:kyc-template/template-name
   "Substantial US Owner"
   :kyc-template/kyc-form-preface
   {:translations {:en "Substantial US Owner information"
                   :fi "Merkittävän US-omistajan tiedot"}}

   :kyc-substantial-us-owner.group/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-substantial-us-owner/full-name {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-substantial-us-owner/street-address {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-substantial-us-owner/city {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-substantial-us-owner/zip-code {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-substantial-us-owner/country {:mandatory-field? process-not-in-draft-status?}]])}

   :kyc-substantial-us-owner.group/tax-information
   {:ord          2.0
    :translations {:en "Tax information"
                   :fi "Verotiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-substantial-us-owner/tax-reference-type {:mandatory-field? process-not-in-draft-status?}]
                    [:kyc-substantial-us-owner/tax-identification-number {:mandatory-field? process-not-in-draft-status?}]])}})
